import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Home.vue'
import AuthView from '../views/AuthView.vue'
import Dashboard from '../views/Dashboard.vue'
import AccountStatus from '../views/AccountStatus.vue'
import Documents from '../views/Documents.vue'
import Profile from '../views/Profile.vue'

import Login from '../components/auth/login'
import Register from '../components/auth/register'
import Recover from '../components/auth/recover'

const Users = () => import(/* webpackChunkName: "users" */ '../views/Users.vue')

import store from '@/store'

Vue.use(VueRouter)

const checkAuthenticated = (to, from, next) => {
    if( !store.getters['auth/authenticated'] ){
        return next({
            name: 'auth.login'
        })
    }
    next()
}

const routes = [
    {
        path: '/',
        component: Main,
        beforeEnter: checkAuthenticated,
        children: [
            { path: '', name: 'home', component: Dashboard },
            { path: 'home', name: 'dashboard', component: Dashboard },
            { path: 'account-status', name: 'account.status', component: AccountStatus },
            { path: 'documents', name: 'documents', component: Documents },
            { path: 'profile', name: 'profile', component: Profile },
            { path: 'users', name: 'users', component: Users },
        ]
    },
    {
        path: '/auth',
        component: AuthView,
        children: [
            { path: '', name: 'auth', component: Login }, 
            { path: 'login', name: 'auth.login', component: Login }, 
            { path: 'recover', name: 'auth.recover', component: Recover },
            { path: 'register', name: 'auth.register', component: Register }
        ]
    },
    { path: '*', redirect: '/', beforeEnter: checkAuthenticated }
]

const router = new VueRouter({
	mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: "is-active",
	routes
})

export default router
